module.exports = __webpack_public_path__ + "assets/images/facebook_share.a25b42b5a9eaef2b41230d3b58cf2f35.svg";